import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';
export function About() {
  const team = [{
    name: 'Louis Fitzsimmons',
    role: 'CEO',
    description: 'Entrepreneurial leader with experience scaling transport and technology businesses'
  }, {
    name: 'Rohan Bhavale',
    role: 'CTO',
    description: 'AIoT and platform engineering lead with experience delivering scalable, production-ready systems'
  }, {
    name: 'Charles De Courcel',
    role: 'CFO',
    description: 'Finance leader specialising in growth, structuring and scaling environments'
  }, {
    name: 'Balazs Berki',
    role: 'CRO',
    description: 'Leads industry engagement, market development and strategic partnerships across public transport ecosystems'
  }];
  return <>
      <PageHero eyebrow="ABOUT" headline="Decision-grade intelligence for public transport systems" data-id="element-219" />

      {/* Company Summary */}
      <section className="bg-sure-dark w-full py-24 md:py-32" data-id="element-220">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-221">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex flex-col space-y-8 text-sure-gray text-base md:text-lg font-light leading-relaxed max-w-4xl" data-id="element-222">
            <p data-id="element-223">
              SURE AI defines the intelligence layer for public transport
              systems, converting existing onboard data into decision-grade
              passenger intelligence that operators and authorities can act on
              with confidence.
            </p>
            <p data-id="element-224">
              Across bus networks globally, vast volumes of operational data
              already exist within onboard CCTV and vehicle systems yet remain
              largely underutilised at network level. SURE AI activates this
              infrastructure by transforming passive video and vehicle signals
              into structured, anonymised operational evidence that supports
              safer operations, more reliable services and better-informed
              planning decisions.
            </p>
            <p data-id="element-225">
              Designed for complex, regulated environments, the approach
              prioritises auditability, consistency and interoperability,
              enabling decisions that are measurable, explainable and
              defensible. Deployment is phased and infrastructure-led,
              integrating with existing systems without requiring replacement or
              identity-based tracking.
            </p>
            <p data-id="element-226">
              As deployment expands across networks, SURE AI establishes
              consistent, comparable intelligence at system level, enabling
              operators and authorities to manage performance, safety and
              capacity with greater precision and accountability.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team */}
      <section className="bg-sure-black w-full py-24 md:py-32 border-t border-white/5" data-id="element-227">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-228">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium mb-16" data-id="element-229">
            Leadership
          </motion.h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-230">
            {team.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: index * 0.1
          }} className="flex flex-col" data-id="element-231">
                <div className="aspect-[3/4] w-full mb-6 overflow-hidden bg-[#1a1a1a]" data-id="element-232">
                  <img src="https://cdn.magicpatterns.com/uploads/uXptVYRhsGKqFm9q3Hcchz/a1f0b75f-f31b-4d12-8103-aa5417726baa.jpg" alt={member.name} className="w-full h-full object-cover grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-233" />
                </div>
                <h3 className="text-sure-white text-lg font-bold mb-2" data-id="element-234">
                  {member.name}
                </h3>
                <p className="text-sure-accent text-xs uppercase tracking-widest font-medium mb-4" data-id="element-235">
                  {member.role}
                </p>
                <p className="text-sure-gray text-sm font-light leading-relaxed" data-id="element-236">
                  {member.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Who we work with */}
      <section className="bg-sure-dark w-full py-24 md:py-32 border-t border-white/5" data-id="element-237">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 text-center" data-id="element-238">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium mb-8" data-id="element-239">
            Who we work with
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="text-sure-white text-xl md:text-2xl lg:text-3xl font-light leading-relaxed max-w-4xl mx-auto" data-id="element-240">
            Public transport authorities, public and private operators, industry
            partners, associations and system integrators
          </motion.p>
        </div>
      </section>

      <CTASection data-id="element-241" />
    </>;
}